var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 8.42488V14.9375C2.625 15.6337 2.90156 16.3014 3.39384 16.7937C3.88613 17.2859 4.55381 17.5625 5.25 17.5625H15.75C16.4462 17.5625 17.1139 17.2859 17.6062 16.7937C18.0984 16.3014 18.375 15.6337 18.375 14.9375V7.0625C18.375 6.36631 18.0984 5.69863 17.6062 5.20634C17.1139 4.71406 16.4462 4.4375 15.75 4.4375H5.25C4.55381 4.4375 3.88613 4.71406 3.39384 5.20634C2.90156 5.69863 2.625 6.36631 2.625 7.0625V8.42488ZM5.25 5.75H15.75C16.0981 5.75 16.4319 5.88828 16.6781 6.13442C16.9242 6.38056 17.0625 6.7144 17.0625 7.0625V8.03375L10.5 11.567L3.9375 8.03375V7.0625C3.9375 6.7144 4.07578 6.38056 4.32192 6.13442C4.56806 5.88828 4.9019 5.75 5.25 5.75ZM3.9375 9.52475L10.1889 12.89C10.2845 12.9415 10.3914 12.9684 10.5 12.9684C10.6086 12.9684 10.7155 12.9415 10.8111 12.89L17.0625 9.52475V14.9375C17.0625 15.2856 16.9242 15.6194 16.6781 15.8656C16.4319 16.1117 16.0981 16.25 15.75 16.25H5.25C4.9019 16.25 4.56806 16.1117 4.32192 15.8656C4.07578 15.6194 3.9375 15.2856 3.9375 14.9375V9.52475Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c797694c219ddd6a517f8a629dd00a71.svg";
export { ForwardRef as ReactComponent };